import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Grid,
	Tooltip,
	Typography,
	Box,
	useTheme,
	Chip,
	Divider,
	IconButton,
	Paper,
	lighten,
	Button,
} from "@mui/material";
import useStyles from "./styles";
import dayjs from "dayjs";
import { useState } from "react";
import {
	VisibilityOff,
	Visibility,
	CheckCircleOutlineOutlined,
	WhatsApp,
	Star,
	AddOutlined,
} from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";

import { BusinessOutlined } from "@mui/icons-material";

import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

import PublishedWithChangesOutlinedIcon from "@mui/icons-material/PublishedWithChangesOutlined";
import OfflinePinOutlinedIcon from "@mui/icons-material/OfflinePinOutlined";

import DatagridComponent from "../../datagridComponent";
import ModalNewTicketIxc from "../../tickets/modalNewTicketIxc";
import GrupoChip from "../../grupoEconomico/GrupoChip";

export default function AccordionIxc(params) {
	const {
		id,
		baseData,
		cliente,
		dataAtivacao,
		dataExpiracao,
		endereco,
		planoContrato,
		renovacaoAutomatica,
		status,
		statusInternet,
		enderecoPadraoCliente,
		validade,
		valor,
		vencimento,
		setSnackbar,
		logins,
		statusIsento,
		vendedorContrato,
		filial,
		canalVendas,
		clienteInfo,
		descricao,
		ownerNome,
		// Novo ticket do serviço: ERP e código do dono ({ erp, erpId, clienteErpId }).
		ticket = {},
	} = params;
	const theme = useTheme();
	const styles = useStyles(theme);
	const [openNewTicket, setOpenNewTicket] = useState(false);
	const [selectedService, setSelectedService] = useState(null);
	const waitingReturn = ["Pré-cadastro"];
	const enabledService = ["Ativo"];

	function formatarMoedaBR(input) {
		if (!valor) return "R$ 0,00";

		const numeroLimpo = valor.toString().replace(/[^\d.]/g, "");

		const numero = parseFloat(numeroLimpo);

		if (isNaN(numero)) return "R$ 0,00";

		return numero.toLocaleString("pt-BR", {
			style: "currency",
			currency: "BRL",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	}

	const columns = [
		{
			field: "login",
			headerName: "Login",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "senha",
			headerName: "Senha",
			flex: 0.5,
			minWidth: 100,
		},
		{
			field: "ip",
			headerName: "IP",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "mac",
			headerName: "MAC",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "download",
			headerName: "Download",
			flex: 0.3,
			minWidth: 150,
		},
		{
			field: "upload",
			headerName: "Upload",
			flex: 0.3,
			minWidth: 150,
		},
		{
			field: "concentrador",
			headerName: "Concentrador",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "endereco",
			headerName: "Endereço",
			flex: 3,
			minWidth: 150,
			renderCell: (params) => {
				const end = params.row.endereco;
				const isPadrao = params.row.enderecoPadraoCliente === "S";

				if (!end) return "-";

				const textoEndereco = `${end.endereco}, ${end.bairro}, ${end.cidade} - ${end.estado}, Nº ${end.numero} - CEP: ${end.cep}`;

				return (
					<Box display="flex" alignItems="center" gap={1}>
						{isPadrao && (
							<Tooltip title="Endereço Padrão">
								<CheckCircleOutlineOutlined
									sx={{ fontSize: 18, color: theme.palette.success.main }}
								/>
							</Tooltip>
						)}
						<Typography
							variant="body2"
							sx={{
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
							}}
						>
							{textoEndereco}
						</Typography>
					</Box>
				);
			},
		},
	];
	const handleCloseNewTicket = () => {
		setOpenNewTicket(false);
		setSelectedService(null);
	};
	const handleOpenNewTicket = () => {
		setOpenNewTicket(true);
	};

	async function CopyTexto({ campo }) {
		try {
			await navigator.clipboard.writeText(campo);
		} catch (err) {
			const textArea = document.createElement("textarea");
			textArea.value = campo;
			document.body.appendChild(textArea);
			textArea.select();
			try {
				document.execCommand("copy");
			} catch (err) {
				console.error("Falha ao copiar texto: ", err);
			}
			document.body.removeChild(textArea);
		}
		setSnackbar({
			children: "Campo copiado!",
			severity: "info",
		});
	}
	return (
		<Accordion variant="outlined" elevation={0}>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls="panel1a-content"
				id="panel1a-header"
				sx={styles.accordionSummary}
			>
				<Grid container spacing={1} alignItems="center">
					<Grid item xs={12} sm={8}>
						<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
							<Tooltip title={cliente}>
								<Typography
									variant="subtitle1"
									fontWeight="bold"
									sx={styles.summaryTextOverflow}
								>
									{`${id} - ${cliente}`}
								</Typography>
							</Tooltip>
							{ownerNome && <GrupoChip label={ownerNome} variant="owner" />}
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={4}
						sx={{
							...styles.accordionTextStatus,
							justifyContent: "space-between",
							pr: 2,
						}}
					>
						<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
							<Box
								sx={{
									...styles.statusDot,
									...(waitingReturn.includes(status)
										? {
												bgcolor: theme.palette.colors.orange.light,
												animation: "pulse 1.5s infinite",
												boxShadow: `0 0 10px ${theme.palette.colors.orange.light}`,
											}
										: enabledService.includes(status)
											? {
													bgcolor: theme.palette.colors.green.light,
												}
											: {
													bgcolor: theme.palette.colors.red.light,
												}),
								}}
							/>
							<Tooltip title={status}>
								<Typography
									variant="body2"
									color="text.secondary"
									sx={styles.summaryTextOverflow}
								>
									{status}
								</Typography>
							</Tooltip>
						</Box>
						<Button
							startIcon={<AddOutlined fontSize="small" />}
							variant="contained"
							size="small"
							onClick={(event) => {
								event.stopPropagation();
								handleOpenNewTicket();
								setSelectedService(id);
							}}
						>
							Novo ticket
						</Button>
					</Grid>
					{descricao && (
						<Grid item xs={12} sx={styles.accordionTextStatus}>
							<Typography
								variant="body2"
								fontWeight={600}
								color="text.secondary"
							>
								Descrição Auxiliar:
							</Typography>
							<Tooltip title={descricao}>
								<Typography
									variant="body2"
									color="text.secondary"
									sx={styles.summaryTextOverflow}
								>
									{descricao}
								</Typography>
							</Tooltip>
						</Grid>
					)}
				</Grid>
			</AccordionSummary>
			<Divider />
			<AccordionDetails>
				<Grid container spacing={2} alignItems={"flex-start"}>
					{/*COLUNA 1 */}
					<Grid item xs={12} sm={8}>
						<Grid container spacing={0.2}>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<MonetizationOnOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Valor de Serviço:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: valor })}
										>
											{formatarMoedaBR(valor)}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>

							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<BusinessOutlined sx={styles.icons} />

									<Typography sx={styles.boxEnderecoTitle}>
										Endereço:
									</Typography>
									<Box display="flex" alignItems="" gap={1}>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.boxEnderecoContent}
												onClick={() =>
													CopyTexto({
														campo: `${endereco?.endereco}, ${endereco?.bairro}, ${endereco?.cidade} - ${endereco?.estado} - ${endereco?.numero}`,
													})
												}
											>
												{`${endereco?.endereco}, ${endereco?.bairro}, ${endereco?.cidade} - ${endereco?.estado} - ${endereco?.numero}`}
											</Typography>
										</Tooltip>
										<Box sx={{ mt: 0 }}>
											{enderecoPadraoCliente === "S" && (
												<Tooltip title="Endereço Padrão">
													<CheckCircleOutlineOutlined
														sx={{
															fontSize: 16,
															color: theme.palette.success.main,
														}}
													/>
												</Tooltip>
											)}
										</Box>
									</Box>
								</Box>
							</Grid>

							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<MonetizationOnOutlinedIcon sx={styles.icons} />

									<Typography sx={styles.typhographyTitle}>Plano:</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: planoContrato })}
										>
											{planoContrato}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<PublishedWithChangesOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Renovação Automática:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: renovacaoAutomatica })}
										>
											{renovacaoAutomatica}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<OfflinePinOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Status Isento:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: statusIsento })}
										>
											{statusIsento}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CalendarMonthOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Data de Ativação:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() =>
												CopyTexto({
													campo: dayjs(
														dataAtivacao,
														"YYYY-MM-DD HH:mm:ss",
													).format("DD/MM/YYYY HH:mm"),
												})
											}
										>
											{dataAtivacao &&
												dayjs(dataAtivacao, "YYYY-MM-DD HH:mm:ss").format(
													"DD/MM/YYYY HH:mm",
												)}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>

							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<BusinessOutlined sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>Filial:</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: filial })}
										>
											{filial}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
						</Grid>
					</Grid>
					{/*COLUNA 2 */}

					<Grid item xs={12} sm={4}>
						<Grid container spacing={0.2} alignItems={"flex-start"}>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<PersonOutlineOutlinedIcon sx={{ ...styles.icons }} />
									<Typography sx={styles.typhographyTitle}>
										Vendedor de Contrato:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: vendedorContrato })}
										>
											{vendedorContrato}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<WhatsApp sx={{ ...styles.icons }} />
									<Typography sx={styles.typhographyTitle}>
										Canal de Vendas:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: canalVendas })}
										>
											{canalVendas}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CalendarMonthOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Data de Expiração:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() =>
												CopyTexto({
													campo: dayjs(
														dataExpiracao,
														"YYYY-MM-DD HH:mm:ss",
													)?.format("DD/MM/YYYY HH:mm"),
												})
											}
										>
											{dataExpiracao &&
												dayjs(dataExpiracao, "YYYY-MM-DD HH:mm:ss")?.format(
													"DD/MM/YYYY HH:mm",
												)}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CalendarMonthOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Data Financeiro:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() =>
												CopyTexto({
													campo: dayjs(baseData, "YYYY-MM-DD HH:mm:ss").format(
														"DD/MM/YYYY HH:mm",
													),
												})
											}
										>
											{baseData &&
												dayjs(baseData, "YYYY-MM-DD HH:mm:ss").format(
													"DD/MM/YYYY HH:mm",
												)}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CalendarMonthOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Vencimento:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() => CopyTexto({ campo: vencimento })}
										>
											{` Dia ${vencimento}`}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CalendarMonthOutlinedIcon sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Validade:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() =>
												CopyTexto({
													campo: validade,
												})
											}
										>
											{validade}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>

							<Grid item xs={12}>
								<Box sx={styles.boxCampos}>
									<CheckCircleOutlineOutlined sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Status da Internet:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Chip
											label={statusInternet}
											size="small"
											sx={styles.contratoChip(statusInternet != enabledService)}
											onClick={() => CopyTexto({ campo: statusInternet })}
										/>
									</Tooltip>
								</Box>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</AccordionDetails>
			<Divider sx={{ width: "100%" }} />
			<Paper
				sx={{
					display: "flex",
					...(logins?.length > 10 && { height: "390px" }),
				}}
				elevation={0}
			>
				<DatagridComponent columns={columns} rows={logins || []} />
			</Paper>
			<ModalNewTicketIxc
				open={openNewTicket}
				handleClose={handleCloseNewTicket}
				/*        refrashTIckets={refrashTickets} */
				clienteErpId={ticket?.clienteErpId ?? clienteInfo?.clienteErpId}
				serviceId={selectedService}
				erp={ticket?.erp}
				erpId={ticket?.erpId}
			/>
		</Accordion>
	);
}
